require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-meet-james-from-elementary-school-teacher-to-ui-developer.json") })
        }
      }, "path---blog-meet-james-from-elementary-school-teacher-to-ui-developer");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-meet-james-from-elementary-school-teacher-to-ui-developer!./.cache/json/blog-meet-james-from-elementary-school-teacher-to-ui-developer.json
// module id = 954
// module chunks = 231608221292675